/* ----------------------------------------------------------------------
 * Header terug bij omhoog scrollen — Headsprung, 9-10-2026
 *
 * Het thema maakt de header alleen vast op index, product, collection,
 * search, article en de inlogpagina's. Op gewone pagina's (/pages/...)
 * scrolt hij weg en komt hij nooit meer terug; de position:sticky op de
 * headersectie doet in dit thema niets.
 *
 * Hier vangen we alleen díe pagina's op: scrol je omhoog, dan schuift de
 * header terug in beeld; scrol je weer omlaag, dan verdwijnt hij. Boven
 * aan de pagina valt hij terug in zijn gewone plek, zodat de bovenkant
 * van de pagina er niet anders uitziet dan nu.
 *
 * Pagina's die van het thema al een vaste header krijgen (fixed--true)
 * blijven ongemoeid. Op mobiel werkt het net zo; alleen schuift de header
 * daar niet terug zolang het uitklapmenu, de winkelwagen of het zoekvak
 * openstaat, want dan ligt er al een paneel overheen.
 * -------------------------------------------------------------------- */

(function () {
	const header = document.querySelector('.header');
	if (!header) return;
	if (header.classList.contains('fixed--true')) return;
	if (!header.classList.contains('header-sticky--active')) return;

	let vorige = window.scrollY;
	let vastgezet = false;
	let wachtOpFrame = false;

	// Pas meeschuiven als je voorbij de header bent; anders springt hij
	// aan het begin van de pagina heen en weer.
	function drempel() {
		return header.offsetHeight + 60;
	}

	function zet(aan) {
		if (aan === vastgezet) return;
		vastgezet = aan;
		header.classList.toggle('header--meegeschoven', aan);
	}

	// Ligt er al een paneel over de pagina, dan laten we de header staan.
	function paneelOpen() {
		if (header.classList.contains('open-menu')) return true;
		if (document.querySelector('.mobile-toggle-wrapper[open]')) return true;
		const b = document.body.classList;
		return b.contains('open-cc') || b.contains('open-search') || b.contains('open-cart');
	}

	function kijk() {
		wachtOpFrame = false;

		const y = window.scrollY;
		const omhoog = y < vorige;
		vorige = y;

		// Bovenaan hoort hij altijd terug in zijn gewone plek, ook als er een
		// paneel openstaat. Anders blijft hij plakken nadat je met een open
		// menu naar boven scrolt.
		if (y <= drempel()) {
			zet(false);
			return;
		}

		if (paneelOpen()) return;

		zet(omhoog);
	}

	function opScroll() {
		if (wachtOpFrame) return;
		wachtOpFrame = true;
		window.requestAnimationFrame(kijk);
	}

	window.addEventListener('scroll', opScroll, { passive: true });

	window.addEventListener('resize', function () {
		vorige = window.scrollY;
		kijk();
	});

	// Zodra het uitklapmenu dichtgaat opnieuw kijken, anders blijft de
	// header staan in de stand van vlak voor het openen.
	const uitklap = document.querySelector('.mobile-toggle-wrapper');
	if (uitklap) uitklap.addEventListener('toggle', function () { vorige = window.scrollY; kijk(); });

	kijk();
})();
